import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import { EditActions, editActions } from "../../actions/editActions";
import { nameofFactory, isWrite } from "../../utils/utils";
import Editor from "../../components/Editing/Editor";
import MultipleSelection from "../../components/Editing/MultipleSelection";
import { getRoleOptions } from "../../utils/pdApiUtils";
import TextField from "../../components/Editing/TextField";

type StateProps = {
  editedAADGroup: Api.AADGroup;
  storedAADGroup: Api.AADGroup;
  pdApi: State.PdApi;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleModal: () => void;
};

const AADGroupFields = nameofFactory<Api.AADGroup>();

export type EditAADGroupProps = StateProps & DispatchProps & OwnProps;

export class EditAADGroup extends React.Component<EditAADGroupProps> {
  render(): JSX.Element {
    const { editedAADGroup, pdApi, storedAADGroup, activeUser, toggleModal } = this.props;
    const roleOptions = getRoleOptions(pdApi.roles);
    const isNew = !storedAADGroup;

    return (
      <Editor
        itemName={"AADGroup"}
        originalObject={storedAADGroup}
        editedObject={editedAADGroup}
        hasWritePermission={isWrite(activeUser)}
        isValid={this.isAllFieldsValid()}
        cancel={this.props.editActions.cancelEditing}
        update={() => this.props.editActions.update("aadgroups")}
        create={() => this.props.editActions.add("aadgroups")}
        copy={() => this.props.editActions.startEditing(editedAADGroup, true)}
        remove={{ callback: toggleModal }}
      >
        <TextField
          id="name"
          label="AAD Group name"
          value={editedAADGroup.name}
          isError={!this.isFieldValid(AADGroupFields("name"))}
          errorMessage={!this.isEmptyString(editedAADGroup.name) ? "The AAD Group name must be unique." : ""}
          onChange={name => this.props.editActions.setEdited({ ...editedAADGroup, name })}
          disabled={!isNew}
        />

        <br />
        <MultipleSelection
          id="roles"
          label="Roles"
          value={editedAADGroup.roles && editedAADGroup.roles.map(role => role.id)}
          options={roleOptions}
          onChange={roleIds => {
            const roles = roleIds.map((id: number) => ({
              id
            }));
            this.props.editActions.setEdited({
              ...editedAADGroup,
              roles
            });
          }}
        />
      </Editor>
    );
  }

  private isFieldValid = (field: string): boolean => {
    const { pdApi, editedAADGroup, storedAADGroup} = this.props;
    const isNew = !storedAADGroup;
    switch (field) {
      case AADGroupFields("name"): {
        if (this.isEmptyString(editedAADGroup.name)) {
          return false;
        } else {
        return _.values(pdApi.aadgroups).find(
          AADGroup => (isNew || AADGroup.id !== editedAADGroup.id) && 
          AADGroup.name?.toLowerCase() === editedAADGroup.name?.trim().toLowerCase()
        )
          ? false
          : true;
        }
      }
      default:
        return true;
    }
  };

  private isEmptyString = (str: string): boolean => !(!!str.trim() && str.trim().length > 0);

  private isAllFieldsValid = (): boolean => {
    const { editedAADGroup } = this.props;
    const temp = _.keys(editedAADGroup);
    for (const key of temp) {
      if (!this.isFieldValid(key)) {
        return false;
      }
    }
    return true;
  };
}

const mapStateToProps = (state: State.Root) => ({
  editedAADGroup: state.editView.editedObject,
  storedAADGroup: state.editView.storedObject,
  pdApi: state.pdApi,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAADGroup);
